var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlay = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  id: "play_arrow"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_0_205",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  id: "Bounding box",
  width: 20,
  height: 20,
  fill: "#D9D9D9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_0_205)"
}, /*#__PURE__*/React.createElement("path", {
  id: "play_arrow_2",
  d: "M6.66667 14.3125V5.6875C6.66667 5.45139 6.75 5.25347 6.91667 5.09375C7.08333 4.93403 7.27778 4.85417 7.5 4.85417C7.56944 4.85417 7.64236 4.86458 7.71875 4.88542C7.79514 4.90625 7.86806 4.9375 7.9375 4.97917L14.7292 9.29167C14.8542 9.375 14.9479 9.47917 15.0104 9.60417C15.0729 9.72917 15.1042 9.86111 15.1042 10C15.1042 10.1389 15.0729 10.2708 15.0104 10.3958C14.9479 10.5208 14.8542 10.625 14.7292 10.7083L7.9375 15.0208C7.86806 15.0625 7.79514 15.0937 7.71875 15.1146C7.64236 15.1354 7.56944 15.1458 7.5 15.1458C7.27778 15.1458 7.08333 15.066 6.91667 14.9062C6.75 14.7465 6.66667 14.5486 6.66667 14.3125ZM8.33333 12.7917L12.7083 10L8.33333 7.20833V12.7917Z",
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/play.22af00abd3070c90955a277bb92b694c.svg";